import { client } from './api-client';

export const mggFetchFavoriteVideos = () => client.get(`mgg/favorites`);
